/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useRef, useState } from "react";
import { useSelector, shallowEqual } from "react-redux";
import Portal from "../portal";
import { FiX } from "react-icons/fi";

const MetaPopup = ({
  open,
  setOpen,
  value,
  handleSave,
}) => {
  const [data, setData] = useState(value);

  const { palettes } = useSelector((state) => ({ palettes: state.palettes, }), shallowEqual);
  let { background } = { ...palettes, };

  const modalRef = useRef(null);

  const hide = () => {
    setOpen(false);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (!modalRef || !modalRef.current) return false;
      if (!open || modalRef.current.contains(event.target)) {
        return false;
      }
      setOpen(!open);
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [open, modalRef]);

  useEffect(() => {
    setData(value);
  }, [value])

  return (
    <>
      {open && (
        <Portal selector="#portal">
          <div className="modal-backdrop fade-in"></div>
          <div className={`modal show add_faq_cat_modal ${background === "dark" ? "dark-mode" : ""}`} data-background={background} >
            <div className="relative min-w-sm w-auto mx-auto lg:max-w-5xl" ref={modalRef} >
              <div className="modal-content">
                <div className="modal-header">
                  <h3 className="text-xl font-semibold">Meta Description</h3>
                  <button className="modal-close btn btn-transparent" onClick={hide} >
                    <FiX size={18} className="stroke-current" />
                  </button>
                </div>
                <div className="relative p-4 flex-auto faq_box_inner">
                  <div style={{ width: 500 }}>
                    <textarea
                      type="text"
                      placeholder="Please Enter Description"
                      name="name"
                      value={data}
                      onChange={(e) => {
                        setData(e.target.value);
                      }}
                      className="inputFields"
                      cols={30}
                      rows={10}
                    />
                  </div>
                </div>
                <div className="modal-footer space-x-2">
                  <button className="btn btn-default btn-rounded bg-gray-500 hover:bg-gray-600 text-white" type="button" onClick={hide} >
                    Close
                  </button>
                  <button className="btn btn-default btn-rounded bg-blue-500 hover:bg-blue-600 text-white" type="button" onClick={() => handleSave(data)} >
                    Save Changes
                  </button>
                </div>
              </div>
            </div>
          </div>
        </Portal>
      )}
    </>
  );
};

export default MetaPopup;
